module.exports = __webpack_public_path__ + "mainassets/img/SOPRONI_Inno.af05417c.png";